import { Configuration, InteractionType, LogLevel } from "@azure/msal-browser";
import { MSAL_REDIRECT_PAGE_URL, SIGNIN_USERFLOW } from "@/constants";

const debug: boolean = false;

const loggerCallback = (
    level: LogLevel,
    message: string,
    containsPii: boolean,
) => {
    if (containsPii) {
        return;
    }
    switch (level) {
        case LogLevel.Error:
            console.error(message);
            return;
        case LogLevel.Info:
            if (debug) {
                console.info(message);
            }
            return;
        case LogLevel.Verbose:
            if (debug) {
                console.debug(message);
            }
            return;
        case LogLevel.Warning:
            console.warn(message);
            return;
    }
};
export class ADConfig {
    /**
     * Either 'ad' for staff login, or 'adb2c' for enterprise (DNSPs)
     */
    public readonly id: string;
    public readonly msal: Configuration;
    public readonly scopes: Array<string>;
    constructor(id: string, msal: Configuration, scopes: Array<string>) {
        this.id = id;
        this.msal = msal;
        this.scopes = scopes;
    }
}

export const MsalConfigAD: ADConfig = getMsalConfigAD();
export const MsalConfigADB2C: ADConfig = getMsalConfigADB2C(undefined);

function getMsalConfigAD(): ADConfig {
    const appClientId = "cd38c93b-839f-4c7a-8192-6f2eb9d51b64";

    const tenantId = "9435bca8-eece-4f52-99ce-0e7307501304";
    const scopes = [
        "api://8de0460e-0722-4aee-85ff-10cc6c62ac32/access_as_user",
    ];

    /**
     * Configuration object to be passed to MSAL instance on creation.
     * For a full list of MSAL.js configuration parameters, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
     */
    const msal: Configuration = {
        auth: {
            clientId: appClientId,
            authority: `https://login.microsoftonline.com/${tenantId}`, // Defaults to "https://login.microsoftonline.com/common"
            redirectUri: MSAL_REDIRECT_PAGE_URL, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
            postLogoutRedirectUri: "/staff?logout=success", // Indicates the page to navigate after logout.
        },
        cache: {
            cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        },
        system: {
            loggerOptions: {
                loggerCallback: loggerCallback,
            },
        },
    };

    return new ADConfig("ad", msal, scopes);
}
export function getMsalConfigADB2C(
    customUserFlowId: string | undefined,
): ADConfig {
    const tenant = import.meta.env.VITE_ADB2C_TENANT ?? "jetchargedev";
    const appClientId =
        import.meta.env.VITE_ADB2C_CLIENT_ID ??
        "2dd9f83c-9527-43a7-b421-10180ec47426";

    const userFlowId = customUserFlowId ?? SIGNIN_USERFLOW;
    const scopes = [
        import.meta.env.VITE_ADB2C_SCOPE ??
            "https://jetchargedev.onmicrosoft.com/a9820d88-52a9-48fb-91fd-096b91311610/access_as_user",
    ];
    /**
     * Configuration object to be passed to MSAL instance on creation.
     * For a full list of MSAL.js configuration parameters, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
     */
    const msal: Configuration = {
        auth: {
            clientId: appClientId,
            authority: `https://${tenant}.b2clogin.com/tfp/${tenant}.onmicrosoft.com/${userFlowId}`,
            knownAuthorities: [`${tenant}.b2clogin.com`],
            redirectUri: MSAL_REDIRECT_PAGE_URL, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
            postLogoutRedirectUri: "/?logout=success", // Indicates the page to navigate after logout.
        },
        cache: {
            cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        },
        system: {
            loggerOptions: {
                loggerCallback: loggerCallback,
            },
        },
    };
    return new ADConfig("adb2c", msal, scopes);
}

export const AuthInteractionType = InteractionType.Redirect;
